<template>
	<div>
		<el-card>
			<el-form :inline="true" ref="selectForm" :model="formInline" class="demo-form-inline" style="" size="mini">
				<el-form-item label="门店名称">
					<el-input v-model="formInline.store_name" placeholder="可模糊搜索" clearable></el-input>
				</el-form-item>
			
				<el-form-item>
					<el-button type="primary" @click="getData()">查询</el-button>
				</el-form-item>
			</el-form>
		</el-card>
		<el-card style="margin-top: 10px;">
			<el-table :data="data.cashList"  style="width: 100%;text-align: center;"  size="mini">
				<el-table-column align="center" header-align="center" label="编号" width="100">
					<template slot-scope="scope">
						{{scope.$index + 1}}
					</template>
				</el-table-column>
				<el-table-column align="center" header-align="center" prop="store_name" label="门店名称">
				</el-table-column>
				<el-table-column align="center" header-align="center" prop="alipay_login_user" label="支付宝提现账号">
				</el-table-column>
				<el-table-column align="center" header-align="center" prop="cash_amount" label="提现金额">
				</el-table-column>
				<el-table-column align="center" header-align="center" prop="after_store_blance" label="账号余额">
				</el-table-column>
				<el-table-column align="center" header-align="center" prop="" label="提现时间">
					<template slot-scope="scope">
						{{timeFormat(scope.row.cash_date,'yyyy-mm-dd hh:MM:ss')}}
						<!-- <el-button size="mini" type="danger" @click="deleteStore(scope.$index, scope.row)">取消认证</el-button> -->
					</template>
				</el-table-column>
				
				<!-- <el-table-column align="center" header-align="center" label="打款" width="150">
					<template slot-scope="scope">
						<el-button type="danger" @click="finishCash(scope.$index, scope.row)">确定打款</el-button>
					</template>
				</el-table-column> -->
				<el-table-column align="center" header-align="center" label="手动打款" width="150">
					<template slot-scope="scope">
						<el-button type="danger" @click="confirimCash(scope.$index, scope.row)">已打款</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div style="display: flex;justify-content: flex-end; ">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="formInline.page"
				 :page-sizes="[10, 20, 50, 100]" :page-size="formInline.limit" layout="total, sizes, prev, pager, next, jumper"
				 :total="data.cashListTotal">
				</el-pagination>
			</div>
		</el-card>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				formInline: {
					page: 1,
					limit: 20,
					store_name: '',
					cash_state:0
				},
				data: []
			}
		},
		mounted() {
			this.getData();
		},
		methods: {
			
			confirimCash(index,row){
				var that = this;
				this.$confirm('确定已经打款吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '还没有', 
					type: 'warning'
				}).then(() => {
					that.$axios.post('zuche/cash/confirimCash', row).then(function(res) {
						if (res.data.success) {
							that.getData();
						} else {
							that.$message.error(res.data.message);
						}
					});
				})
			},

			handleSizeChange(e) {
				this.formInline.limit = e;
				this.getData();
			},
			handleCurrentChange(e) {
				this.formInline.page = e;
				this.getData();
			},
			finishCash(index, row) {
				var that = this;
				this.$confirm('确定转账?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '考虑以下', 
					type: 'warning'
				}).then(() => {
					that.$axios.post('zuche/cash/aliPay', row).then(function(res) {
						if (res.data.success) {
							that.getData();
						} else {
							that.$message.error(res.data.message);
						}
					});
				})
			},
			getData() {
				var that = this;
				this.$axios.post('zuche/cash/getCashList', this.formInline).then(function(res) {
					console.log(res);
					if (res.data.success) {
						that.data = res.data.result;
					} else {
						that.$message.error(res.data.message);
					}
				});
			}
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/tixianshenqing.vue